// Auto-generated file - do not edit manually
export const LOCALE_HASH = 'f7cb4746';
